import React from 'react';
import { ReactComponent as AlertIcon } from '../../../assets/Alert.svg';
import '../../../stylesheets/triagebot/Errors.scss';

const ErrorMessage = ({ message, isSpanish = false }) => {
    const errorText = message.text || (isSpanish ? 'Se produjo un error.' : 'An error occurred.');

    return (
        <div className='error card'>
            <div className='content'>
                <div className='icon'>
                    <AlertIcon />
                </div>
                <div className='body'>
                    {errorText}
                </div>
            </div>
        </div>
    );
}

export default ErrorMessage;
